module.exports = __webpack_public_path__ + "img/Postmodernisme_Campbells-Soup.353fc3f0.jpg";